import React, { useState } from "react";
import AppLoading from "../../../AppLoading";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TaxonomiesService from "../../../services/TaxonomiesService/TaxonomiesService";
import TaxonomyForm from "../TaxonomyForm/TaxonomyForm";

const AddTaxonomy = (props) => {
  const { vocabularyName: vocabularyNameParam, vocabularyId: vocabularyIdParam } =
    useParams();
  const vocabularyName = props.vocabularyName ?? vocabularyNameParam;
  const vocabularyId = props.vocabularyId ?? vocabularyIdParam;

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function doAddTaxonomyTerm(values) {
    values.vocabulary_id = parseInt(vocabularyId);
    values.weight = parseInt(values.weight);

    setIsLoading(true);

    const termSuccessfullyAdded = await TaxonomiesService.createTaxonomyTerm(values);

    setIsLoading(false);

    if (termSuccessfullyAdded) {
      toast.success(`Successfully added '${values.label}' taxonomy term.`);
    } else {
      toast.error(`Failed to add '${values.label}' taxonomy term.`);
    }

    navigate("/taxonomies");
  }

  if (isLoading) {
    return <AppLoading />;
  }

  return <TaxonomyForm onSubmit={doAddTaxonomyTerm} vocabularyName={vocabularyName} />;
};

export default AddTaxonomy;
